import { useSelector } from "react-redux";

import { RootState } from "@/reducers/types";
import { UserRole } from "@/sx-layout/components/plotmap/models";

export const useAuthorization = () => {
  const userRole = useSelector((state: RootState) => state.layoutApp.layoutMasters.user_role);

  return {
    isAdmin: userRole === UserRole.MASTER_ROLE,
    isUser: userRole === UserRole.USER_ROLE,
    isSpectator: userRole === UserRole.SPECTATOR_ROLE,
  };
};
